import request from '@/utils/request'
// 手机号验证码获取
export function getsms(params) {
  return request({
    url: '/sms/sendSms',
    method: 'get',
    params
  })
}
// 邮箱验证码获取
export function getemail(data) {
  return request({
    url: '/mail/sendMail',
    method: 'post',
     data: { email: data.email }  // 使用data传递
  })
}
// 短信登录功能
export function loginsms(data) {
  return request({
    url: '/info/gpts_user/loginBySms',
    method: 'post',
    data
  })
}
// 邮箱登录功能
export function loginemail(data) {
  return request({
    url: '/info/gpts_user/loginByEmail',
    method: 'post',
    data
  })
}
// 退出登录
export function loginout() {
  // 从 localStorage 获取 token
  const token = localStorage.getItem('token');
  console.log('登出时使用的token:', token); // 调试
  return request({
    url: '/info/gpts_user/logout',
    method: 'post',
    headers: {
      'Authorization': `Bearer ${token}`  // 添加 Authorization 头
    }
  }).finally(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('gptsUserId')
    localStorage.removeItem('gptsUserName')
  })
}
// 根据用户id获取用户的信息
export function getUserInfo(userId) {
  return request({
    url: `/info/gpts_user/${userId}`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 手机号绑定
export function bindPhone1(data) {
  return request({
    url: '/info/gpts_user/bind-phone',
    method: 'post',
    data,
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 手机号换绑
export function changePhone(data) {
  return request({
    url: '/info/gpts_user/change-phone',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 邮箱绑定
export function bindEmail(data) {
  return request({
    url: '/info/gpts_user/bind-email',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 邮箱换绑
export function changeEmail(data) {
  return request({
    url: '/info/gpts_user/change-email',
    method: 'post',
    data,
        headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}
// 获取用户信息
export function getUserInfo1(userId) {
  return request({
    url: `/info/gpts_user/judgment_info/${userId}`,
    method: 'get',
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}`, // 从localStorage获取token
      'Content-Type': 'application/json'
    }
  })
}